import { ActivityEventProcessType } from '@warebee/shared/import-converter';

export const packingKpis /*: WarehouseKPI[] */ = [
  {
    id: 'packing_rate',
    processType: ActivityEventProcessType.PACKING,
    category: 'process',
    title: 'Packing Rate',
    description: 'Number of orders packed per hour',
    unit: 'orders/hr',
    formula: 'COUNT(packed_orders) / SUM(packing_labor_hours)',
    tags: ['packing', 'productivity', 'labor'],
    benchmark: {
      standards: {
        site: {
          target: 40,
          warning: { lower: 35 },
          critical: { lower: 30 },
          basis: 'Legacy benchmark migrated',
        },
      },
      primarySource: 'site',
      timeWindows: [
        {
          name: 'default',
          duration: 'P28D',
          thresholdType: 'static',
          ranges: [
            { label: 'Critical', min: 0, max: 30 },
            { label: 'Warning', min: 30.01, max: 35 },
            { label: 'Target', min: 35.01, max: 40 },
          ],
        },
      ],
      metadata: { source: 'baseline' },
    },
    trendWindow: 'P28D',
    drillDimensions: ['packer_id', 'order_size', 'packaging_type'],
    alertTopic: 'warehouse.alerts.process.packing_rate',
  },
];

export default packingKpis;
